<template>
  <div id="home" class="column is-full">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li v-for="(routeBreadcrumb, index) in routeBreadcrumbs" :key="index"><a :href="routeBreadcrumb.path" @click="$router.push(routeBreadcrumb.path)">{{ routeBreadcrumb.name }}</a></li>
      </ul>
    </nav>
    <template v-if="hasCustomer">
      <section class="hero is-small py-4">
        <div class="hero-body">
          <p class="title has-text-centered">{{ customer.account_name }}</p>
        </div>
      </section>
      <section class="py-4">
        <div class="columns">
          <div class="column m-1">
            <order-items-placed-pie-chart title="Item Categories (Outstanding)" column="item_category"></order-items-placed-pie-chart>
          </div>
          <div class="column m-1">
            <order-items-placed-pie-chart title="Projector Models (Outstanding)" column="projector_model"></order-items-placed-pie-chart>
          </div>
        </div>
        <div class="columns">
          <div class="column m-1">
            <order-items-placed-pie-chart title="RDD Tail Types (Outstanding, Packs)" column="dart_tail_type"></order-items-placed-pie-chart>
          </div>
          <div class="column m-1">
            <order-items-placed-column-chart title="RDD Body Sizes (Outstanding, Packs)" column="dart_body_size"></order-items-placed-column-chart>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import store from '@/store'
import { titleCase } from '@/filters'
import { mapGetters, mapActions } from 'vuex'

// import ChannelPartnerCommitmentVsShippedChart from '@/components/charts/ChannelPartnerCommitmentVsShippedChart'
import OrderItemsPlacedPieChart from '@/components/charts/OrderItemsPlacedPieChart'
import OrderItemsPlacedStackedBarChart from '@/components/charts/OrderItemsPlacedStackedBarChart'
import OrderItemsPlacedColumnChart from '@/components/charts/OrderItemsPlacedColumnChart'
// import CommissionChart from '@/components/charts/CommissionChart'

export default {
  computed: {
    ...mapGetters([
      'user',
      'customer'
    ]),
    routeBreadcrumbs() {
      return [
        ...this.$route.meta.breadcrumbs,
      ]
    },
    hasCustomer() {
      return (this.user.customer_id) ? true : false
    }
  },
  components: {
    // ChannelPartnerCommitmentVsShippedChart,
    OrderItemsPlacedPieChart,
    OrderItemsPlacedStackedBarChart,
    OrderItemsPlacedColumnChart
    // CommissionChart
  },
  filters: {
    titleCase
  }
}
</script>
